/**
 * Lightweight analytics helper — fire-and-forget.
 * Tracks a session id in localStorage (opaque, no PII).
 * Never blocks the UI; silent on failure.
 */
import { api } from "./api";

const SESSION_KEY = "netfotech_session_id";

function getSessionId() {
    try {
        let id = localStorage.getItem(SESSION_KEY);
        if (!id) {
            id =
                typeof crypto !== "undefined" && crypto.randomUUID
                    ? crypto.randomUUID()
                    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
            localStorage.setItem(SESSION_KEY, id);
        }
        return id;
    } catch {
        return "";
    }
}

/**
 * Fire an analytics event. Never throws.
 * @param {string} event - event name (snake_case, e.g. 'service_offering_expanded')
 * @param {object} properties - optional key/value context
 */
export function trackEvent(event, properties = {}) {
    try {
        const payload = {
            event,
            properties: properties || {},
            path:
                typeof window !== "undefined"
                    ? `${window.location.pathname}${window.location.search}${window.location.hash}`
                    : "",
            referrer: typeof document !== "undefined" ? document.referrer : "",
            session_id: getSessionId(),
        };
        // Fire-and-forget — we do NOT await this and we swallow errors.
        api.post("/analytics/event", payload).catch(() => {});
    } catch {
        // Never bubble analytics errors.
    }
}

// Named events — centralised to keep the vocabulary consistent.
export const EVENTS = {
    SERVICE_OFFERING_EXPANDED: "service_offering_expanded",
    PRACTICE_LEAD_CTA_CLICKED: "practice_lead_cta_clicked",
    CASE_STUDY_CLICKED: "case_study_clicked",
    CONTACT_SUBMITTED: "contact_submitted",
    CAREER_APPLIED: "career_applied",
    NEWSLETTER_SUBSCRIBED: "newsletter_subscribed",
};
